import { render } from "./UnsubmittedLiquidations.vue?vue&type=template&id=13d4cad7"
import script from "./UnsubmittedLiquidations.vue?vue&type=script&lang=js"
export * from "./UnsubmittedLiquidations.vue?vue&type=script&lang=js"

import "./UnsubmittedLiquidations.vue?vue&type=style&index=0&id=13d4cad7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__